import React  from 'react';
import BooleanComponentProto from './boolean-proto.jsx';


export default function renderBooleanInView(id, props) {
    return <BooleanComponentProto renderMode="view" id={id} {...props} />;
}